module.exports = __webpack_public_path__ + "img/cover-promotion-bg-mobile.7b791817.jpg";